import React, { useEffect, useLayoutEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Switch, useLocation } from "react-router-dom";
// helper
import { OnboardingRoute } from "helper/route";
import {
  decodePhcPreviewAuthToken,
  isPhcOnboardingPreviewPath,
} from "helper/phcPreviewAuthToken";
import { localStore } from "stores/localStorage";
import { customerActions } from "stores/customer/customerActions";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";
import { PHCOnboardingApis } from "stores/PHC/PHCOnboarding/PHCOnboardingApis";
// layout
import PHCOnboardingLayout from "pages/PHC/Onboarding/PHCOnboardingLayout/PHCOnboardingLayout";

// pages
import PhcOverview from "pages/PHC/Onboarding/Overview/PhcOverview";
import UploadPortfolio from "pages/PHC/Onboarding/UploadPreview/UploadPortfolio";
import PreviewPortfolio from "pages/PHC/Onboarding/UploadPreview/PreviewPortfolio";
import PHCCkyc from "pages/PHC/Onboarding/PHCCkyc/PHCCkyc";
import PHCGenerateReport from "pages/PHC/Onboarding/GenerateReport/PHCGenerateReport";
import PHCLoaderReport from "pages/PHC/Onboarding/PHCLoaderReport/PHCLoaderReport";
import { PHCOnboardingParser } from "stores/PHC/PHCOnboarding/PHCOnboardingParser";

const PhcOnboardingNavigator = (props) => {
  const { match } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated,
  );
  const isPhcOnboardingCompleted = useSelector(
    (state) => state.PHC.PHCOnboarding.isOnboardingCompleted,
  );

  const consentId = useSelector((state) => state.PHC.PHCOnboarding.consentId);

  const previewTokenParam = useMemo(() => {
    return new URLSearchParams(location.search).get("token");
  }, [location.search]);

  const isPreviewRoute = isPhcOnboardingPreviewPath(location.pathname);

  const parsedPreviewAuth = useMemo(() => {
    if (!isPreviewRoute || !previewTokenParam) return null;
    return decodePhcPreviewAuthToken(previewTokenParam);
  }, [isPreviewRoute, previewTokenParam]);

  const detailResponse = async () => {
    const detailRes = await PHCOnboardingApis.getOnboardingData();
    const parsedOnboardingData = PHCOnboardingParser.onboardingData(detailRes);

    return parsedOnboardingData;
  };

  useLayoutEffect(() => {
    if (!parsedPreviewAuth?.token) return;

    const initialize = async () => {
      try {
        localStore.setToken(parsedPreviewAuth.token);
        localStore.setLegacyToken(parsedPreviewAuth.legacyToken);

        dispatch(customerActions.updateAuthStatus(true));

        const detailRes = await detailResponse();

        const consentId = detailRes?.consentId;

        if (consentId) {
          const consentStatus = await PHCOnboardingApis.getConsentId({
            consentId,
          });

          console.log("consentStatus", consentStatus);
        }

        const updateResponseDetail = await detailResponse();
        dispatch(
          PHCOnboardingActions.updatePHCOnboardingData(updateResponseDetail),
        );
      } catch (error) {
        console.error("Initialization failed:", error);
      }
    };

    initialize();
  }, [parsedPreviewAuth, dispatch]);

  const isPreviewRouteAuthenticated =
    isAuthenticated || Boolean(parsedPreviewAuth?.token);

  return (
    <Switch>
      <PHCOnboardingLayout {...props}>
        <Switch>
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/overview`}
            component={PhcOverview}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/portfolio-upload`}
            component={UploadPortfolio}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isPreviewRouteAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/preview`}
            component={PreviewPortfolio}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/ckyc`}
            component={PHCCkyc}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/generate-portfolio`}
            component={PHCLoaderReport}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isPhcOnboardingCompleted}
            // redirectOnboardingIncomplete={`/phc/dashboard`} // old code to redirect if any onboarding completed  
            redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
            path={`${match.path}/save-portfolio`}
            component={PHCGenerateReport}
          />
        </Switch>
      </PHCOnboardingLayout>
    </Switch>
  );
};

export default PhcOnboardingNavigator;
